import $ from 'jquery';
const lang = $('html').attr('lang');

const getLanguage = function(){
  return lang;
}

export { getLanguage }
